var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 12,
    fill: "#001F63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1367_8216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7378 36.3633C28.9686 36.3633 26.3129 37.4633 24.3548 39.4214L17.9644 45.8118C16.0063 47.7699 14.9062 50.4256 14.9062 53.1948C14.9062 58.9614 19.5809 63.636 25.3474 63.636C28.1166 63.636 30.7723 62.5359 32.7304 60.5778L37.1507 56.1576C37.1507 56.1575 37.1508 56.1576 37.1507 56.1576L50.0299 43.2784C50.9651 42.3432 52.2334 41.8178 53.556 41.8178C55.7702 41.8178 57.6473 43.2609 58.2982 45.2579L62.3628 41.1932C60.5085 38.289 57.2572 36.3633 53.556 36.3633C50.7868 36.3633 48.1311 37.4633 46.173 39.4214L28.8735 56.7209C27.9383 57.6561 26.67 58.1815 25.3474 58.1815C22.5934 58.1815 20.3608 55.9489 20.3608 53.1948C20.3608 51.8723 20.8862 50.6039 21.8213 49.6687L28.2117 43.2784C29.1469 42.3432 30.4152 41.8178 31.7378 41.8178C33.9521 41.8178 35.8292 43.261 36.48 45.258L40.5447 41.1933C38.6904 38.2891 35.4391 36.3633 31.7378 36.3633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6919 56.7209C49.7567 57.6561 48.4884 58.1815 47.1658 58.1815C44.9519 58.1815 43.0749 56.7387 42.4239 54.7421L38.3594 58.8066C40.2137 61.7105 43.4649 63.636 47.1658 63.636C49.935 63.636 52.5907 62.5359 54.5488 60.5778L71.8483 43.2784C72.7835 42.3432 74.0518 41.8178 75.3744 41.8178C78.1285 41.8178 80.361 44.0504 80.361 46.8045C80.361 48.127 79.8356 49.3954 78.9005 50.3306L72.5101 56.7209C71.5749 57.6561 70.3066 58.1815 68.984 58.1815C66.7699 58.1815 64.8928 56.7385 64.2419 54.7416L60.1774 58.8063C62.0316 61.7104 65.2829 63.636 68.984 63.636C71.7532 63.636 74.4089 62.5359 76.367 60.5778L82.7574 54.1875C84.7155 52.2294 85.8156 49.5736 85.8156 46.8045C85.8156 41.038 81.1409 36.3633 75.3744 36.3633C72.6052 36.3633 69.9495 37.4633 67.9914 39.4214L50.6919 56.7209Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1367_8216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.9091,
    height: 27.2727,
    fill: "white",
    transform: "translate(14.9062 36.3633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerLogo);
export default __webpack_public_path__ + "static/media/BannerLogo.01ba8d8bdced310a99e36edeed94269e.svg";
export { ForwardRef as ReactComponent };